import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IYearlevel_map } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const EditYearlevel_mapSlice = createSlice({
  name: "EditYearlevel_mapSlice",
  initialState: {} as IReduxState<IYearlevel_map>,
  reducers: {
    EditYearlevel_map: (state, _: PayloadAction<IYearlevel_map>) => {
      state.isLoading = true;
    },
    successEditYearlevel_map: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditYearlevel_map: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditYearlevel_mapResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  EditYearlevel_map,
  failureEditYearlevel_map,
  successEditYearlevel_map,
  clearEditYearlevel_mapResponse,
} = EditYearlevel_mapSlice.actions;

export default EditYearlevel_mapSlice.reducer;
